// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"570":"af5b2a34","3583":"e766ae8f","4992":"af5b2a34","7248":"e766ae8f"}[chunkId] + ".chunk.css";
};